import type { CityConfig } from "../city-template/types";

export const twinFallsConfig: CityConfig = {
  city: "Twin Falls",
  state: "Idaho",
  stateAbbr: "ID",
  slug: "twin-falls",
  route: "/cities/twin-falls",
  title: "Twin Falls ID Passport — Expedited & Emergency Service | Fast Passport Center",
  metaDescription: "Expedited and emergency passport services in Twin Falls, Idaho — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Twin Falls, Jerome, Buhl, Filer, and all Magic Valley communities.",
  h1: "Expedited Passport Services in Twin Falls, ID",
  heroSubtitle: "College of Southern Idaho study abroad program departing soon? Business trip connecting through Salt Lake City? Magic Valley family vacation to Mexico booked for spring break? Twin Falls residents — from CSI students to Chobani and Glanbia professionals to Snake River Canyon outdoor enthusiasts — trust us for fast, reliable passport processing. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30–100% lower than FedEx, Staples, and other third-party resellers. As fast as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Breathtaking%20panoramic%20view%20of%20Twin%20Falls%20Idaho%20with%20the%20Snake%20River%20Canyon%20and%20Perrine%20Bridge%20spanning%20the%20dramatic%20gorge%2C%20Shoshone%20Falls%20waterfall%20cascading%20in%20the%20distance%2C%20golden%20hour%20sunlight%20over%20the%20Magic%20Valley%20landscape%2C%20wide%20scenic%20shot%20with%20agricultural%20fields%20and%20basalt%20cliffs%2C%20editorial%20nature%20photography&width=1800&height=700&seq=twin-falls-hero-2026&orientation=landscape",
  heroImageAlt: "Twin Falls Idaho Snake River Canyon with Perrine Bridge at golden hour",
  geoPosition: "42.5610;-114.3840",
  geoPlacename: "Twin Falls, Idaho",
  lastModified: "2026-06-15",
  regionalAgency: {
    name: "Denver Passport Agency",
    address: "Cherry Creek III, 3151 S Vaughn Way, Suite 600, Aurora, CO 80014",
    distance: "Closest regional agency — approximately 700 miles, appointments required",
  },
  nearbyCitiesZips: [
    { name: "Twin Falls", zips: "83301, 83303" },
    { name: "Jerome", zips: "83338" },
    { name: "Buhl", zips: "83316" },
    { name: "Filer", zips: "83328" },
    { name: "Kimberly", zips: "83341" },
    { name: "Burley", zips: "83318" },
    { name: "Rupert", zips: "83350" },
  ],
  benefits: [
    { icon: "ri-flashlight-line", title: "24-Hour Magic Valley Emergency Processing", desc: "Reserved courier access — as fast as 24 hours for Twin Falls and Magic Valley travelers with immediate international departures from TWF or BOI." },
    { icon: "ri-flight-takeoff-line", title: "TWF & BOI Airport Expertise", desc: "Joslin Field (TWF) connects to Salt Lake City, while Boise Airport (BOI) offers broader hub connections. We know both airports and their international routing dynamics." },
    { icon: "ri-graduation-cap-line", title: "CSI Student & Agribusiness Focus", desc: "College of Southern Idaho students studying abroad and Magic Valley agribusiness professionals traveling for international trade — we understand the region's unique passport needs." },
    { icon: "ri-home-heart-line", title: "Magic Valley Family Specialists", desc: "From first-time passports for Jerome kids to renewals for Buhl retirees heading south — we make the process clear, fast, and stress-free for the whole Magic Valley." },
  ],
  internalLinks: [
    { name: "Fast passport services in Boise, ID", route: "/cities/boise" },
    { name: "Expedited services in Idaho Falls, ID", route: "/cities/idaho-falls" },
    { name: "Idaho passport services overview", route: "/states/idaho" },
  ],
  fpcOfficeAddress: "3151 S Vaughn Way, Suite 600, Aurora, CO 80014",
  fpcOfficeNote: "Fast Passport Center serves Twin Falls via secure registered courier with direct access to State Department processing. Our registered couriers hand-deliver your documents — meaning Magic Valley residents get faster results without driving to Denver. Ship from any UPS Store, FedEx Office, or post office in Twin Falls County.",
  fpcOfficeDistance: "Serving Twin Falls, Jerome, Buhl, Filer, Kimberly, Burley, Rupert, and all Magic Valley communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Twin Falls and the greater Magic Valley region. From the Snake River Canyon corridor to the agricultural communities of Jerome and Buhl, from the CSI campus to the Blue Lakes business district — we serve all of south-central Idaho. Our courier service eliminates the need for any long-distance travel.",
  nearbyCitiesIntro: "We serve Twin Falls and all Magic Valley communities including Jerome, Buhl, Filer, Kimberly, Burley, and Rupert. We also serve travelers departing from Joslin Field-Magic Valley Regional Airport (TWF) and Boise Airport (BOI) who need emergency passports.",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in Twin Falls as simple as possible. Because we are a registered U.S. Department of State courier (not a reseller like FedEx or Staples), we pass those savings directly to you with our best price guarantee. Most Twin Falls travelers start online and ship documents overnight — no office visit required.",
  mistakesIntro: "Magic Valley travelers encounter unique passport issues — from last-minute agribusiness trade missions to spring break bookings with expired documents. Here are the most common passport mistakes we see from this area.",
  testimonialsIntro: "Twin Falls and Magic Valley travelers — from CSI students to Jerome families to Buhl professionals — trust us when their international departure is days away.",
  faqIntro: "Have questions about expedited passports in Twin Falls, ID? Here are the most common ones we hear from Magic Valley travelers.",
  statePageRoute: "/states/idaho",
  statePageName: "Idaho",
  servicesIntro: "Whether you need a renewal before a TWF-to-SLC international connection, an emergency passport for a last-minute overseas business trip, or a first-time passport for your Magic Valley family vacation abroad — Fast Passport Center handles it with reserved courier submission availability. As a registered State Department courier (not a reseller), we guarantee the best price and typically cost 30–100% less than FedEx, Staples, and other third-party passport courier resellers.",
  dmvWebsite: "https://itd.idaho.gov/dmv/",
  dmvLabel: "Idaho Transportation Department — DMV Services",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Local Area", href: "#service-area" },
    { label: "Travel", href: "#travel-timing" },
    { label: "Destinations", href: "#destinations" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Ideal for upcoming trips", "Document review included", "Dedicated agent assigned", "Daily status updates", "No need to travel anywhere"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned", "Daily status updates"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent", "Updates only by physical mail", "Cannot upgrade speed after submission"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Closest agency is Denver (700 miles)", "Not practical for Magic Valley travelers"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "International flight connecting through SLC in two days? Overseas trade mission this week? Our emergency courier service submits via reserved agency slots — as fast as 24 hours for Magic Valley travelers.",
      bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help Twin Falls residents renew fast — no agency visit required. Perfect for Magic Valley professionals and agribusiness travelers.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time applicants require an in-person acceptance clerk visit. We guide Twin Falls residents through every step with clear instructions for the nearest acceptance facility.",
      bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Replacements require additional forms. We guide you through DS-64 and everything needed to avoid costly mistakes — so your travel plans are not derailed.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minors require parental participation and an in-person acceptance step. We provide clear instructions and checklists for Magic Valley families.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "After marriage, divorce, or a legal name change — we assist with corrected passports so your travel documents match your reservations.",
      bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "The passport card is a wallet-size travel document for land and sea crossings to Canada, Mexico, the Caribbean, and Bermuda.",
      bullets: ["Wallet-size convenience", "Land and sea travel", "Same expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Twin Falls ID", description: "Urgent passport processing for Twin Falls Idaho travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Twin Falls ID", description: "Fast passport renewal for Twin Falls Idaho residents with a previously-issued passport." },
    { name: "First-Time Passport Twin Falls ID", description: "New passport application services for Twin Falls Idaho residents applying for their first passport." },
    { name: "Child Passport Twin Falls ID", description: "Minor passport services for Twin Falls Idaho families with children under 16." },
    { name: "Name Change Passport Twin Falls ID", description: "Passport name correction after marriage, divorce, or legal name changes for Twin Falls residents." },
    { name: "Passport Card Twin Falls ID", description: "Passport card services for land and sea crossings from Twin Falls Idaho." },
  ],
  testimonials: [
    {
      name: "The Johnsons",
      location: "Twin Falls",
      rating: 5,
      text: "Booked a trip to Cancun for spring break and realized all four of our passports were expired. Fast Passport Center handled everything — we shipped documents and all four passports arrived in 8 days. Incredible service.",
      service: "Family Passport Renewal",
    },
    {
      name: "Dave K.",
      location: "Jerome",
      rating: 5,
      text: "I work in agribusiness and needed a renewal in a hurry for a trade mission to Europe. Fast Passport Center got it back in 5 business days. The document review was thorough and professional.",
      service: "Passport Renewal",
    },
    {
      name: "Rachel S.",
      location: "Twin Falls — CSI Student",
      rating: 5,
      text: "Accepted to a CSI study abroad program in Costa Rica with only 5 weeks before departure. Never had a passport. They guided me through every step as a first-time applicant and I got my passport in 6 days.",
      service: "New Passport",
    },
    {
      name: "Mike & Linda B.",
      location: "Buhl",
      rating: 5,
      text: "Retired and booked a Mediterranean cruise, then realized our passports expired during the pandemic. Fast Passport Center processed both renewals in a week and we made the cruise departure.",
      service: "Passport Renewal",
    },
  ],
  facilities: [
    {
      id: "twinfalls-1",
      name: "Twin Falls Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "253 2nd Ave W",
      city: "Twin Falls",
      state: "ID",
      zip: "83301",
      phone: "(208) 733-2922",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      distance: "Downtown Twin Falls",
      website: "https://tools.usps.com/find-location.htm?location=1377586",
      websiteLabel: "USPS Location",
      notes: "Primary passport acceptance facility in Twin Falls. Passport photos available. Appointment recommended — call ahead, especially during spring break season.",
      icon: "ri-mail-line",
    },
    {
      id: "twinfalls-2",
      name: "Twin Falls County Clerk",
      type: "County Clerk Passport Acceptance",
      address: "425 Shoshone St N",
      city: "Twin Falls",
      state: "ID",
      zip: "83301",
      phone: "(208) 736-4004",
      hours: "Mon–Fri 8:00 AM – 5:00 PM",
      distance: "Downtown Twin Falls",
      website: "https://www.twinfallscounty.org/clerk/",
      websiteLabel: "Twin Falls County Clerk",
      notes: "County clerk passport acceptance services. Serves all Twin Falls County residents. No photo services on-site — bring your own photos.",
      icon: "ri-government-line",
    },
    {
      id: "twinfalls-3",
      name: "Jerome Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "120 1st Ave E",
      city: "Jerome",
      state: "ID",
      zip: "83338",
      phone: "(208) 324-2311",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      distance: "Jerome — 10 miles north",
      website: "https://tools.usps.com/find-location.htm?location=1377538",
      websiteLabel: "USPS Location",
      notes: "Serves Jerome and northern Twin Falls County. Smaller facility with limited appointment slots — book in advance during peak seasons.",
      icon: "ri-mail-line",
    },
    {
      id: "twinfalls-4",
      name: "Burley Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1353 Oakley Ave",
      city: "Burley",
      state: "ID",
      zip: "83318",
      phone: "(208) 678-3149",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      distance: "Burley — 38 miles east",
      website: "https://tools.usps.com/find-location.htm?location=1377496",
      websiteLabel: "USPS Location",
      notes: "Serves Burley, Rupert, and eastern Magic Valley communities. Good backup option if Twin Falls appointments are full.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — Denver agency is 700 miles away", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Required — drive 700 miles to Denver or fly there", fpc: "Most Magic Valley travelers ship documents overnight" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only — strict eligibility", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection and delay", fpc: "Professional review to reduce processing delays" },
    { feature: "Courier Access", agency: "Not available to the public", fpc: "Reserved daily submission availability as registered courier" },
    { feature: "Predictability", agency: "Appointments can be cancelled — no guarantee", fpc: "Predictable processing based on selected speed option" },
    { feature: "Who Can Use It", agency: "Strict eligibility — urgent travel with proof of departure", fpc: "Most U.S. citizens with required documentation" },
    { feature: "Cost vs Resellers", agency: "Government fees only — but you handle logistics", fpc: "Best price guarantee — 30-100% less than FedEx, Staples & resellers" },
    { feature: "Magic Valley Guidance", agency: "Generic — no TWF/BOI airport or CSI expertise", fpc: "Full Magic Valley/TWF Airport/CSI knowledge built in" },
  ],
  mistakes: [
    {
      icon: "ri-error-warning-line",
      title: "Spring Break Booking Without Passport Check",
      description: "Magic Valley families frequently book spring break trips to Mexico or the Caribbean in January without checking passports. By the time they discover expired documents in late February or March, standard timelines are strained. Check passports at booking time.",
    },
    {
      icon: "ri-error-warning-line",
      title: "CSI Study Abroad Timeline Compression",
      description: "College of Southern Idaho students accepted to study abroad programs often have just 4–6 weeks from acceptance to departure. First-time applicants need both an acceptance facility visit and processing time — leaving things to the last two weeks creates panic.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Photo Standards Violations",
      description: "Many Magic Valley pharmacies and big-box stores produce photos that fail State Department standards. We catch this in review before it causes a rejection and adds weeks to your timeline.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Missing Parental Consent for Minors",
      description: "Magic Valley families frequently overlook the DS-3053 consent form when one parent is unavailable. This is an automatic rejection — we guide you through it correctly.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Not Accounting for 6-Month Rule",
      description: "Twin Falls travelers booking to Asia, Europe, or South America often do not know their passport must have 6 months remaining beyond the return date. We flag this immediately during review.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose the processing speed that fits your travel date and complete your secure order. Takes just a few minutes from your home or office." },
    { number: "02", icon: "ri-file-list-3-line", title: "We Confirm & Send Your Checklist", description: "We confirm your details and provide a personalized checklist, instructions, and document review guidance tailored to your travel situation." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Your Documents Overnight", description: "Send your documents using an overnight shipping option. Most Twin Falls clients ship from any UPS Store or FedEx Office in the Magic Valley." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "We submit through our reserved passport agency availability — so you do not have to drive 700 miles to Denver." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Is Completed", description: "Your passport is completed within the timeframe you selected. No guessing, no hoping an appointment opens up — just certainty." },
  ],
  faqs: [
    { q: "How fast can I get a passport in Twin Falls?", a: "We offer Twin Falls-area clients expedited processing as fast as 24 hours. Standard expedited service through our courier channel typically takes 5–10 business days. We review your documents before submission to catch errors that cause delays." },
    { q: "Is there a passport office in Twin Falls?", a: "The Twin Falls Main Post Office at 253 2nd Ave W serves as a passport acceptance facility for first-time applications. The Twin Falls County Clerk at 425 Shoshone St N also provides acceptance services. For expedited processing beyond the standard timeline, our registered courier service is the fastest option." },
    { q: "Can CSI students apply for passports on campus?", a: "The College of Southern Idaho does not have an on-campus passport acceptance facility. CSI students should use the Twin Falls Post Office or Twin Falls County Clerk for their acceptance clerk visit. We provide step-by-step guidance for CSI students applying for study abroad programs." },
    { q: "Where is the closest passport agency to Twin Falls?", a: "The Denver Passport Agency is approximately 700 miles away. It requires appointments and serves life-or-death emergencies only. For all other expedited passport needs, our courier channel is faster and eliminates the need for long-distance travel." },
    { q: "Can you help with passports for flights from Twin Falls Airport?", a: "Yes. Joslin Field-Magic Valley Regional Airport (TWF) connects to Salt Lake City International Airport, a major Delta hub. Boise Airport (BOI) is also 2 hours away with broader connections. We regularly assist Magic Valley travelers with expedited passports for connections through both airports." },
    { q: "What documents do Twin Falls applicants need?", a: "New passport: certified birth certificate, government-issued photo ID, DS-11 form, and passport photo. Renewal: DS-82 form, current passport, and passport photo. Child passport: DS-11, birth certificate, both parents or notarized consent, and photos. We provide a Twin Falls-specific checklist." },
    { q: "Where can I get passport photos in Twin Falls?", a: "The Twin Falls Post Office, Walgreens on Blue Lakes Blvd N, and Staples on Pole Line Rd all offer passport photo services. We recommend confirming photo standards compliance before visiting." },
    { q: "What is the best price for expedited service in Twin Falls?", a: "Government fees are $130 + $60 expedite fee. Our courier fee covers document review, overnight shipping, and State Department submission. Total cost is typically 30–100% lower than FedEx, Staples, and other third-party resellers." },
    { q: "How do I check my Twin Falls passport status?", a: "Once submitted, we provide tracking at every stage. You can also check the State Department's online passport status system at travel.state.gov. Processing from Twin Falls to final return shipping typically matches your chosen speed tier." },
  ],
  travelTiming: {
    title: "Travel & Passport Timing for Twin Falls Residents",
    intro: "Twin Falls anchors south-central Idaho's Magic Valley — a growing agricultural, manufacturing, and education hub. Here's what Magic Valley travelers need to know about passport timing.",
    cards: [
      {
        icon: "ri-flight-takeoff-line",
        title: "TWF — Joslin Field-Magic Valley Regional Airport",
        subtitle: "Regional airport with daily Delta Connection flights to Salt Lake City",
        description: "Magic Valley Regional Airport offers daily flights to Salt Lake City International Airport (SLC), connecting south-central Idaho to Delta's global network. With nonstop service from SLC to London, Paris, Amsterdam, Mexico City, and Tokyo, TWF is the Magic Valley's gateway to the world. The short 10-minute drive from downtown Twin Falls makes it extremely convenient — but that convenience sometimes masks the need for passport readiness.",
        tip: "TWF-to-SLC connection flights mean your passport must be valid at check-in in Twin Falls, not just at the SLC international gate. Delta agents will check your international documentation at TWF.",
      },
      {
        icon: "ri-plant-line",
        title: "Magic Valley Agribusiness & International Trade",
        subtitle: "Chobani, Glanbia, and the dairy industry's global connections",
        description: "Twin Falls is home to the world's largest yogurt plant (Chobani) and a major Glanbia cheese manufacturing facility. The Magic Valley's dairy and food processing industry generates regular international business travel — executives visiting European parent companies, food scientists attending international conferences, and sales teams traveling to markets in Asia and Latin America. These trips are often scheduled on short notice.",
        tip: "Agribusiness travelers should maintain a current passport at all times. International trade missions and corporate meetings in Europe or Asia frequently come with 1–3 weeks of notice.",
      },
      {
        icon: "ri-landscape-line",
        title: "Shoshone Falls Tourism & Seasonal Travel Patterns",
        subtitle: "Tourism peaks and how they affect passport demand",
        description: "Shoshone Falls — the 'Niagara of the West' — draws visitors from around the world, and the tourism industry creates international travel demand. Twin Falls residents working in hospitality and tourism frequently travel to international destinations themselves. Spring break (March) and summer vacation (June–August) are the busiest passport processing seasons for the Magic Valley.",
        tip: "If you are booking spring break or summer international travel, start your passport process in January or February — before the Magic Valley rush begins.",
      },
    ],
  },
  destinations: {
    title: "Where Twin Falls Travelers Go — And Why Passports Get Urgent",
    intro: "Magic Valley residents travel abroad for business, education, family, and recreation. Mexico and Canada are the top destinations, but Europe and Asia travel is growing rapidly with the region's international business connections.",
    stats: [
      { stat: "40%", label: "of Twin Falls expedited requests are for family vacations — spring break Mexico, summer Europe trips" },
      { stat: "3–5 Weeks", label: "average lead time Magic Valley travelers have from booking to international departure" },
      { stat: "Feb–Apr", label: "peak season when spring break bookings, agribusiness trade missions, and CSI study abroad converge" },
      { stat: "7 Days", label: "typical turnaround for Twin Falls-area expedited passport processing" },
    ],
    destinations: [
      { name: "Mexico", context: "Cancun, Puerto Vallarta, Cabo — spring break and winter escape favorites for Magic Valley families", urgency: "Spring break bookings peak January–February with fixed departure dates", icon: "ri-map-pin-2-line" },
      { name: "Europe", context: "Agribusiness trade missions, food industry conferences, CSI faculty research trips", urgency: "Industry conference dates and trade show schedules are fixed and non-negotiable", icon: "ri-map-pin-2-line" },
      { name: "Asia", context: "Dairy technology collaborations in Japan and South Korea, food safety conferences", urgency: "Business trips with 2–4 weeks of notice and complex visa requirements", icon: "ri-map-pin-2-line" },
      { name: "Canada", context: "British Columbia road trips, Vancouver getaways, Banff and Jasper national parks", urgency: "Summer road trips booked 2–4 weeks out, families discover passport issues at packing time", icon: "ri-map-pin-2-line" },
      { name: "Caribbean Cruises", context: "Popular with Magic Valley families, departing Seattle or Florida ports", urgency: "Cruise line documentation deadlines are strict with no flexibility", icon: "ri-map-pin-2-line" },
    ],
    crossLinksTitle: "Explore Other Idaho Service Areas",
    crossLinksDesc: "We serve travelers across Idaho with the same fast, reliable passport processing.",
    crossLinks: [
      { name: "Boise", route: "/cities/boise" },
      { name: "Idaho Falls", route: "/cities/idaho-falls" },
    ],
  },
  photoLocations: [
    { name: "Twin Falls Post Office", address: "253 2nd Ave W, Twin Falls, ID 83301", hours: "Mon–Fri 9 AM – 4 PM" },
    { name: "Walgreens — Twin Falls", address: "170 Blue Lakes Blvd N, Twin Falls, ID 83301", hours: "Daily 7 AM – 11 PM" },
    { name: "Staples — Twin Falls", address: "1649 Pole Line Rd E, Twin Falls, ID 83301", hours: "Mon–Fri 8 AM – 8 PM, Sat 9 AM – 6 PM" },
    { name: "The UPS Store — Twin Falls", address: "1410 Blue Lakes Blvd N, Twin Falls, ID 83301", hours: "Call for hours" },
  ],
  dmvLocations: [
    {
      name: "Twin Falls County DMV",
      address: "630 Addison Ave W, Twin Falls, ID 83301",
      hours: "Mon–Fri 8:00 AM – 5:00 PM",
      note: "Driver licenses, REAL ID, vehicle registration. Appointment recommended.",
      featured: true,
    },
  ],
  airports: [
    {
      code: "TWF",
      name: "Joslin Field-Magic Valley Regional Airport",
      distance: "About 10 minutes from downtown Twin Falls",
      address: "492 Airport Loop, Twin Falls, ID 83301",
      note: "Regional airport with daily Delta Connection flights to Salt Lake City International Airport (SLC), a major international gateway.",
      flightUrl: "https://www.tfid.org/274/Airport",
      flightLabel: "TWF Airport Website",
      featured: true,
    },
    {
      code: "BOI",
      name: "Boise Airport",
      distance: "About 2 hours from Twin Falls",
      address: "3201 W Airport Way, Boise, ID 83705",
      note: "Larger airport with connections to Seattle, Denver, Salt Lake City, Phoenix, and Minneapolis — all major international gateway hubs.",
      flightUrl: "https://www.iflyboise.com/",
      flightLabel: "Boise Airport Website",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified birth certificates from Idaho Vital Records. Online, mail, or in-person options available for Twin Falls County.",
      url: "https://healthandwelfare.idaho.gov/services-programs/birth-death-marriage-divorce",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate",
      desc: "Obtain certified death certificates through Idaho Vital Records. Required for estate and legal matters in Twin Falls County.",
      url: "https://healthandwelfare.idaho.gov/services-programs/birth-death-marriage-divorce",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request marriage license records from the Twin Falls County Clerk. Certified copies available for name changes and legal purposes.",
      url: "https://www.twinfallscounty.org/clerk/",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce records through the Twin Falls County District Court. Required for name change passport corrections.",
      url: "https://www.twinfallscounty.org/courts/",
    },
  ],
};